import React, { useEffect, useState } from "react";
import axios from "axios";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import { translations } from "../translations";
import { Button, Modal, useMediaQuery, useTheme } from "@mui/material";
import { red } from "@mui/material/colors";
import { useSnackbar } from "notistack";

const AccountPage = ({
  subscriptionStatus,
  setSubscriptionStatus,
  siteLanguage,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  axios.defaults.withCredentials = true;
  const [billingHistory, setBillingHistory] = useState({});
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleConfirm = async () => {
    try {
      // Cancel subscription on the server
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/cancel-subscription`
      );

      // Here, you can handle the response however you'd like
      if (response.data.message) {
        console.log(response.data.message);
        setSubscriptionStatus(false);
        enqueueSnackbar("Subscription canceled!", { variant: "success" });
      }
    } catch (error) {
      console.error("Error cancelling subscription:", error);
      enqueueSnackbar(
        "Error cancelling subscription. Please reach out to customer service.",
        { variant: "error" }
      );
    }

    handleClose();
  };

  useEffect(() => {
    // Fetch the billing history
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/user/billing`)
      .then((response) => {
        console.log(response.data);

        // Format the subscriptionStart date
        if (response.data.subscriptionStart) {
          const date = new Date(response.data.subscriptionStart);
          const formattedDate = `${date.getFullYear()}-${String(
            date.getMonth() + 1
          ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
          response.data.subscriptionStart = formattedDate;
        }

        setBillingHistory(response.data);
      })
      .catch((error) => {
        console.error("Error fetching billing history:", error);
      });
  }, []);

  const modalBody = (
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        bgcolor: "background.paper",
        boxShadow: 24,
        p: 4,
        width: fullScreen ? "70%" : "50%",
      }}
    >
      <Typography id="modal-modal-title" variant="h6" component="h2">
        Are you sure you want to cancel your subscription?
      </Typography>
      <Box
        sx={{
          marginTop: 2,
          flexDirection: fullScreen ? "column" : "row",
          display: "flex",
          justifyContent: "flex-start",
        }}
      >
        <Button variant="contained" color="primary" onClick={handleConfirm}>
          Yes
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleClose}
          sx={{ marginTop: fullScreen ? 2 : 0, marginLeft: fullScreen ? 0 : 2 }}
        >
          No
        </Button>
      </Box>
    </Box>
  );

  return (
    <Container component="main">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography component="h1" variant="h5">
          My Account
        </Typography>

        <Box component="div" sx={{ mt: 3, width: "100%" }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Card variant="outlined">
                <CardContent>
                  <Typography variant="h6">
                    Subscription Status:{" "}
                    {subscriptionStatus ? "Active" : "Inactive"}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12}>
              <Card variant="outlined">
                <CardContent>
                  <Typography variant="h6">Billing History</Typography>
                  <Typography variant="body1">
                    Subscription Start: {billingHistory.subscriptionStart}
                  </Typography>
                  <Typography variant="body1">
                    Subscription Valid Until:{" "}
                    {billingHistory.subscriptionValidUntil}
                  </Typography>
                  <Typography variant="body1">
                    Auto Renew: {billingHistory.autoRenew ? "Yes" : "No"}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          {subscriptionStatus && (
            <Box display="flex" justifyContent="center" marginTop={3}>
              <Button
                sx={{
                  backgroundColor: "maroon",
                }}
                variant="contained"
                color="primary"
                onClick={handleOpen}
              >
                Cancel Subscription
              </Button>
              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                fullScreen={fullScreen}
              >
                {modalBody}
              </Modal>
            </Box>
          )}
        </Box>
      </Box>
    </Container>
  );
};

export default AccountPage;
